import { getDefaultConfig } from './getDefaultConfig';
import {
  createEhrPatientDemographicCallback,
  createEhrPatientProxiesCallback
} from '../utils';

/**
 * Function that returns the Crm-specific config for Direct Book.
 * @param {Object} props - The config properties
 * @param {string} props.customerCode - represents a customer
 * @param {Object} props.location - the react-router location object
 * @param {Object} props.tokens - tokens from pmc redux store
 * @param {Object} props.searchSDK
 * @param {Object} props.crmConnector - interface for crm-connector widget
 * @returns the Crm-specific config
 */
export const getMychartEmbeddedConfig = ({
  customerCode,
  location,
  featureFlags,
  tokens,
  config,
  ehrData,
  searchSDK,
  log
}) => {
  const baseConfig = getDefaultConfig({
    customerCode,
    location,
    featureFlags,
    tokens,
    config,
    ehrData,
    searchSDK,
    log
  });

  if (!ehrData) return baseConfig;

  const { data: ehrPatientLookupInfo } = ehrData;
  if (!ehrPatientLookupInfo) return baseConfig;

  const {
    pid = null,
    pid_type = null,
    source_system = null
  } = ehrPatientLookupInfo;
  return {
    ...baseConfig,
    ehr: {
      pid,
      pid_type,
      source_system,
      ...featureFlags
    },
    services: {
      ...baseConfig.services,
      getEhrPatientDemographics: createEhrPatientDemographicCallback(
        log,
        customerCode
      ),
      getEhrPatientProxyDemographics: createEhrPatientProxiesCallback(
        log,
        customerCode
      )
    }
  };
};
